import React, { useState } from "react";
import { Link } from "react-router-dom";
import { backend_domain } from "../helpers";

const CartTableRow = ({ item, cartUpdate }) => {
  const [currentQty, setCurrentQty] = useState(item?.qty);
  return (
    <tr>
      <td>
        <button
          type="button"
          className="remove-tr-btn flex-align gap-12 hover-text-danger-600"
          onClick={() => {
            setCurrentQty(0);

            cartUpdate({
              item_code: item?.item_code,
              qty: 0,
              rate: item?.price,
            });
          }}
        >
          <i className="ph ph-x-circle text-2xl d-flex" />
          Remove
        </button>
      </td>
      <td>
        <div className="table-product d-flex align-items-center gap-24">
          <Link
            to={`/singleProduct?id=${item?.item_code}`}
            className="table-product__thumb border border-gray-100 rounded-8 flex-center "
          >
            <img src={`${backend_domain}${item?.image}`} alt="" />
          </Link>
          <div className="table-product__content text-start">
            <h6 className="title text-lg fw-semibold mb-8">
              <Link
                to={`/singleProduct?id=${item?.item_code}`}
                className="link text-line-2"
                tabIndex={0}
              >
                {item?.item_name}
              </Link>
            </h6>
          </div>
        </div>
      </td>
      <td>
        <span className="text-lg h6 mb-0 fw-semibold">{item?.rate} KD</span>
      </td>
      <td>
        <div className="d-flex rounded-4 overflow-hidden">
          <button
            type="button"
            className="quantity__minus flex-shrink-0 h-48 w-48 text-neutral-600 bg-gray-50 flex-center hover-bg-main-600 hover-text-white"
            onClick={() => {
              setCurrentQty(currentQty - 1);

              cartUpdate({
                item_code: item?.item_code,
                qty: currentQty - 1,
                rate: item?.price,
              });
            }}
          >
            <i className="ph ph-minus" />
          </button>
          <input
            type="number"
            className="quantity__input flex-grow-1 border border-gray-100 border-start-0 border-end-0 text-center px-16"
            style={{width:"100px"}}
            id="stock"
            readOnly
            value={currentQty}
          />
          <button
            type="button"
            onClick={() => {
              setCurrentQty(currentQty + 1);

              cartUpdate({
                item_code: item?.item_code,
                qty: currentQty + 1,
                rate: item?.price,
              });
            }}
            className="quantity__plus flex-shrink-0 h-48 w-48 text-neutral-600 bg-gray-50 flex-center hover-bg-main-600 hover-text-white"
          >
            <i className="ph ph-plus" />
          </button>
        </div>
      </td>
    </tr>
  );
};

export default CartTableRow;
